import { render, staticRenderFns } from "./ModalInquiryDownload.vue?vue&type=template&id=2c011411&"
import script from "./ModalInquiryDownload.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryDownload.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports